import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import {
  ButtonLink,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Flex,
  FlexItem
} from 'components/Library'

import UserActions from './Charts/Page/UserActions'
import TrafficSources from './Charts/Page/TrafficSources'
import RecentClients from './Charts/Page/RecentClients'
import { getPagesByURLRequest } from 'store/thunks/pagesThunks'
import {
  getGlobalAnalyticsRequest,
  getPageAnalyticsRequest,
  getRecentClientsRequest
} from 'store/thunks/analyticsThunks'
import AvgTime from './Charts/Page/AvgTime'
import TotalViews from './Charts/Page/TotalViews'
import UniqueUsers from './Charts/Page/UniqueUsers'
import ViewsPerCity from './Charts/Page/ViewsPerCity'
import ViewsPerLanguage from './Charts/Page/ViewsPerLanguage'

const PageAnalytics = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { url } = useParams()
  const { paginaSeleccionada: pagina } = useSelector((state) => state.pages)

  /**
   * Hook useEffect para obtener la información de la página seleccionada
   * según la URL accedida mediante el thunk {@link getPagesByURLRequest}
   */
  useEffect(() => {
    dispatch(getPagesByURLRequest(url, navigate))
  }, [dispatch, navigate, url])

  useEffect(() => {
    if (pagina.url) {
      dispatch(getRecentClientsRequest())
      dispatch(getPageAnalyticsRequest())
      dispatch(getGlobalAnalyticsRequest())
    }
  }, [dispatch, pagina.url])

  return (
    <Card style={{ margin: '2rem auto', width: '95%' }}>
      <CardHeader color="primary">Estadísticas</CardHeader>
      <CardBody>
        <Flex
          flexWrap="wrap"
          justifyContent="space-between"
          style={{
            gridGap: '2rem'
          }}
        >
          {/* Usuarios totales */}
          <FlexItem
            style={{
              padding: 0
            }}
            flexBasis={32.5}
          >
            <TotalViews />
          </FlexItem>
          {/* Usuarios unicos */}
          <FlexItem
            style={{
              padding: 0
            }}
            flexBasis={32.5}
          >
            <UniqueUsers />
          </FlexItem>
          {/* Tiempo promedio */}
          <FlexItem
            style={{
              padding: 0
            }}
            flexBasis={32.5}
          >
            <AvgTime />
          </FlexItem>

          {/* (doble) */}
          <FlexItem
            style={{
              padding: 0
            }}
            flexBasis={50}
            justifyContent="space-between"
          >
            <FlexItem flexDirection="column" style={{ gridGap: '2rem', padding: 0 }}>
              <ViewsPerLanguage />
              <RecentClients />
            </FlexItem>
          </FlexItem>

          {/* Ciudades accedidas */}
          <FlexItem
            flexBasis={50}
            style={{
              padding: 0,
              alignSelf: 'flex-start'
            }}
          >
            <ViewsPerCity />
          </FlexItem>

          {/* Usuarios activos por mes 222 */}
          <FlexItem
            flexBasis={50}
            style={{
              padding: 0
            }}
          >
            <TrafficSources />
          </FlexItem>
          {/* Acciones de usuario */}
          <FlexItem
            flexBasis={50}
            style={{
              padding: 0
            }}
          >
            <UserActions />
          </FlexItem>
          {/* Acceso a la aplicacion */}
          {/* <FlexItem
            style={{
              padding: 0,
            }}
          >
            <Card style={{ padding: "2rem", width: "100%" }}>
              <Chart
                style={{ width: "100%" }}
                options={{
                  chart: {
                    toolbar: {
                      show: false,
                    },
                  },
                  plotOptions: {
                    bar: {
                      borderRadius: 10,
                    },
                  },
                  xaxis: {
                    categories: ["Nov", "Dic", "Ene", "Feb", "Mar", "Abr"],
                  },
                  title: {
                    text: "Visitas, suscripciones y pagos",
                  },
                  colors: [colors.primary, colors.secondary, colors.tertiary],
                }}
                height={250}
                series={[
                  {
                    name: "Visitas",
                    data: [44, 55, 41, 64, 22, 43],
                  },
                  {
                    name: "Suscripciones",
                    data: [53, 32, 33, 52, 13, 44],
                  },
                  {
                    name: "Pagos",
                    data: [21, 28, 25, 32, 16, 23],
                  },
                ]}
                type="bar"
              />
            </Card>
          </FlexItem> */}
        </Flex>
      </CardBody>
      <CardFooter
        style={{
          borderTop: 0,
          paddingTop: 0
        }}
      >
        <ButtonLink
          borderradius={2}
          color="dark"
          to="/pages"
          text="Regresar"
          style={{
            display: 'block',
            width: 'fit-content'
          }}
        />
        {/* <Button borderradius={2} color="primary" text="Descargar PDF"></Button> */}
      </CardFooter>
    </Card>
  )
}

export default PageAnalytics
